module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"googleTagManager":{"trackingId":"G-QYE6ZRVDM7","cookieName":"acceptStatisticsCookies","defaultDataLayer":{"platform":"gatsby"},"includeInDevelopment":false,"anonymize":true}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
